import { render, staticRenderFns } from "./ModelPage.vue?vue&type=template&id=2db318a8&scoped=true&"
import script from "./ModelPage.vue?vue&type=script&lang=ts&"
export * from "./ModelPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db318a8",
  null
  
)

export default component.exports